import { RumEvent } from "@datadog/browser-rum";
import { redactSensitiveData } from "./redactSensitiveData";
import { redactUrlPathParams } from "./redactUrlPathParams";
import { redactUrlSearchParams } from "./redactUrlSearchParams";

/** Function used to modify a RUM event before it is sent to Datadog.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export type DatadogEventProcessor = (event: RumEvent) => void;

/** Add event processors to this list to enable them. */
const eventProcessors: DatadogEventProcessor[] = [
  redactSensitiveData,
  redactUrlSearchParams,
  redactUrlPathParams,
];

export const processEvent: DatadogEventProcessor = (event) => {
  eventProcessors.forEach((processor) => processor(event));
};
